import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import AddWebsiteLayoutComponent from './website-layout-create.component';
import WebsiteLayoutCardComponent from './website-layout-card.component';



export const WebsitesLayoutComponent = ({handleDelete,setPageData,paginationData,additionButtons,onEdit,columnDefs, id,selectedLayouts,handleInnerFormChange,cardDetails,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Website Layout Information',
        component:<AddWebsiteLayoutComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedLayouts={selectedLayouts}
        />,
        isVisible: id == 0? true: false,
    },
    {
        id:2,
        title:'Website Layout Card Information',
        component:<WebsiteLayoutCardComponent 
        rowData={cardDetails}
        columnDefs={columnDefs}
        onEdit={onEdit}
        additionButtons={additionButtons}
        paginationData={paginationData}
        setPageData={setPageData}
        handleDelete={handleDelete}
        />,
        isVisible: id > 0 ? true : false,
    },
    
  ]
  return (
    <div className="flex flex-col items-center w-full px-5 h-[520px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
      {id == 0 &&<button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>}
           {id == 0 && <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>}
        </div>
       </div>
  )
}
export default WebsitesLayoutComponent;
